import React from 'react';
import PropTypes from 'prop-types';

const TabBar = ({ tabs, activeTab, onChange, className = '', ariaLabel = 'Sections' }) => (
  <div className={`tab-bar ${className}`.trim()}>
    <ul className="nav nav-tabs mb-3" role="tablist" aria-label={ariaLabel}>
      {(tabs || []).map((t) => (
        <li className="nav-item" key={t.id} role="presentation">
          <button
            type="button"
            role="tab"
            id={`tab-${t.id}`}
            aria-selected={activeTab === t.id}
            aria-controls={`tabpanel-${t.id}`}
            className={`nav-link ${activeTab === t.id ? 'active' : ''}`}
            onClick={() => onChange(t.id)}
          >
            {t.label}
          </button>
        </li>
      ))}
    </ul>
  </div>
);

TabBar.propTypes = {
  tabs: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
    })
  ).isRequired,
  activeTab: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  className: PropTypes.string,
  ariaLabel: PropTypes.string,
};

export default TabBar;
